export const PRODUCTS_SORT_OPTIONS = [
  {
    value: 'default',
    label: 'За замовчуванням',
  },
  {
    value: 'name:asc',
    label: "Ім'я: А-Я",
  },
  {
    value: 'name:desc',
    label: "Ім'я: Я-А",
  },
  {
    value: 'price:asc',
    label: 'Ціна: від низької до високої',
  },
  {
    value: 'price:desc',
    label: 'Ціна: від високої до низької',
  },
];
